"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordApplicationBuildId = void 0;
const redux_actions_1 = require("redux-actions");
exports.recordApplicationBuildId = (0, redux_actions_1.createAction)('RECORD_APPLICATION_BUILDID');
